import { render, staticRenderFns } from "./user-configuration-print-tab-model.vue?vue&type=template&id=62988368&scoped=true&"
import script from "./user-configuration-print-tab-model.ts?vue&type=script&lang=ts&"
export * from "./user-configuration-print-tab-model.ts?vue&type=script&lang=ts&"
import style0 from "./user-configuration-print-tab-model.scss?vue&type=style&index=0&id=62988368&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62988368",
  null
  
)

export default component.exports